<body>
  <section>
    <a href="javascript:" id="return-to-top"
      ><img
        src="https://img.icons8.com/metro/26/ffffff/sort-up.png"
        class="top"
        alt="sort-up"
    /></a>
    <div class="container-fluid section-second">
      <div class="row">
        <div class="col-lg-10">
          <div class="row">
            <div class="col-lg-4 text-right logo2">
              <div class="logo">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(jan-29)/assets/image/logo.png"
                  class="logo1"
                  alt="logo"
                />
              </div>
            </div>
            <div class="col-lg-6 text-center index">
              <div class="social-img">
                <a
                  href="https://onpassive.com/blog"
                  target="_blank"
                  rel="noopener"
                  title="ONPASSIVE"
                >
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(jan-29)/assets/image/icon/blog.png"
                    class="icon1"
                    alt="blog"
                  />
                </a>
                <a
                  href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  title="Facebook"
                >
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(jan-29)/assets/image/icon/fb.png"
                    class="icon"
                    alt="facebook"
                  />
                </a>
                <a
                  href="https://twitter.com/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  title="Twitter"
                >
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(jan-29)/assets/image/icon/twitter.png"
                    class="icon"
                    alt="Twitter"
                  />
                </a>
                <a
                  href="https://www.instagram.com/ONPASSIVE/"
                  target="_blank"
                  rel="noopener"
                  title="Instagram"
                >
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(jan-29)/assets/image/icon/insta.png"
                    class="icon"
                    alt="Instagram"
                  />
                </a>
                <a
                  href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  title="Youtube"
                >
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(jan-29)/assets/image/icon/Youtube.png"
                    class="icon"
                    alt="YouTube"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                  target="_blank"
                  rel="noopener"
                  title="Youtube"
                >
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(jan-29)/assets/image/icon/in.png"
                    class="icon"
                    alt="LinkedIn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mt-5">
          <div class="para mt-5">
            <h1 class="style1" data-aos-easing="ease-out-cubic">
              Launching Soon!
            </h1>
            <h3 class="style2">Internet Marketing Solutions!</h3>
            <p class="style3">
              ONPASSIVE specializes in providing the best solutions catered
              towards your business. Our powerful tools are integrated with
              Artificial Intelligence to ensure that you can achieve your goals
              as a business. We are constantly innovating in helping millions of
              entrepreneurs and businesses across the world to achieve their
              dreams!
            </p>
          </div>
          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            class="become"
            target="_blank"
            rel="noopener"
          >
            <img
              src="{{
                onPassiveBaseUrl
              }}onpassive(jan-29)/assets/image/button.png"
              class="become-button1"
              alt="button"
            />
            <span class="become-button">BECOME A FOUNDER NOW</span></a
          >
        </div>
        <div class="col-lg-6"></div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center mt-5">
        <div class="col-lg-12 text-center mt-5">
          <h1 class="ml14">MAKE YOUR DREAMS INTO REALITY!</h1>
          <h2 class="ml15">THE POSSIBILITIES ARE ENDLESS.</h2>
        </div>
      </div>
    </div>
    <div class="container-fluid section-third">
      <div class="row">
        <div class="col-lg-12">
          <div class="row mt-3">
            <div class="col-lg-6"></div>
            <div class="col-lg-6">
              <p class="style10" data-aos-easing="linear">
                You may think that it is impossible to achieve your dreams and
                goals as a business. This is not true! Achieving the impossible
                just takes a little more time. <br />
                ONPASSIVE consists of a team of digital experts who are
                effectively trying to specialize themselves with ideas and
                innovations! Artificial Intelligence helps to specialize in
                witnessing some of the more unique marketing practices!
              </p>
            </div>
            <div class="col-lg-5"></div>
            <div class="col-lg-7">
              <div class="video-box">
                <video
                  id="my-video"
                  class="
                    video-js video-size
                    w-100
                    h-auto
                    my-video-dimensions
                    shadow
                  "
                  controls
                  preload="auto"
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  data-setup="{}"
                  autoplay="true"
                  muted
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div
            class="para1 mt-5"
            data-aos="fade-right"
            data-aos-easing="ease-in-sine"
          >
            <h1 class="font10">
              <span class="blue">The Heart of</span> What's in Store for you
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid section-fourth">
      <div class="row">
        <div class="col-lg-6"></div>
        <div class="col-lg-6 mt-5">
          <ul>
            <li data-aos-easing="linear">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(jan-29)/assets/image/1.png"
                alt="1"
              />
              &nbsp;<span class="para1">Joint Research & Development:</span
              ><br />
              <span class="para10">
                ONPASSIVE helps in providing a community for successful joint
                research and development in building solutions. Joint research
                is incredibly beneficial as it helps to bring together a better
                community of thought leaders and innovators in coming up with
                the best solutions.</span
              >
            </li>
            <li data-aos-easing="linear">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(jan-29)/assets/image/2.png"
                alt="2"
              />
              &nbsp;<span class="para2">Software Enabled Solutions:</span><br />
              <span class="para10">
                ONPASSIVE specializes in providing solutions for businesses
                which are enabled with software. These solutions are great for
                solving complex problems and can effectively help businesses in
                understanding how to capitalize on certain opportunities.</span
              >
            </li>
            <br />
            <li data-aos-easing="linear">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(jan-29)/assets/image/3.png"
                alt="3"
              />
              &nbsp;<span class="para3">Analytical ITES & Web Solutions:</span
              ><br />
              <span class="para10"
                >ONPASSIVE specializes in providing web solutions and greater
                analytical ITES for entrepreneurs, organizations and businesses
                in tackling certain types of problems faced by businesses. These
                types of software work primarily on solving problems in
                industries such as Insurance, Finance, Banking and
                Telecommunication.</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container-fluid section-sixth">
      <div class="row">
        <div class="col-lg-12">
          <div class="copy-right text-center">
            &copy; 2022 ONPASSIVE - All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  </section>
  <!----------------------------------------------------------------------------------------->
</body>
